import { filter, isEmpty, omit, pick } from 'lodash/fp';
import { ProfilePhoneType, ProfileSocialLinkType } from 'types';
import { capMap } from 'utils';

const transformData = (data) =>
  capMap(
    (value, label) => ({
      label,
      value,
    }),
    data,
  );

const getData = (data, entity) =>
  filter(({ value }) => !!value, transformData(pick(entity, data)));

export const prepareData = (data) => {
  const phones = getData(data, Object.values(ProfilePhoneType));
  const links = getData(data, Object.values(ProfileSocialLinkType));
  const fields = omit(
    [
      ...Object.values(ProfileSocialLinkType),
      ...Object.values(ProfilePhoneType),
    ],
    data,
  );

  return {
    ...fields,
    dob: data.dob ? new Date(data.dob).toISOString() : null,
    phones: !isEmpty(phones) ? phones : [],
    links: !isEmpty(links) ? links : [],
  };
};
